import OrganizationDetailTeams from '@/screens/OrganizationDetailTeams';

import useRootStore from '@/stores/useRootStore';

export default function PrivateTabsOrganizationMainTeamsRoute() {
  const organizationId = useRootStore((state) => state.organizationId);

  return <OrganizationDetailTeams organizationId={organizationId || ''} />;
}
